import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {UiPageLoading} from '~/components/elements';
import {useRequestState} from '~/hooks';
import {fetchQuestionnairesAnswerById, fetchQuestionnaires} from '~/redux/questionnaires/thunk';
import {BCPHCheckoutPopup} from '.';

const queryString = require('query-string');

interface Params {
  token: string;
  mdqId: string;
}

const CheckoutPopup = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const query: Params = queryString.parse(location.search);
  const {mdqId} = query;
  const {loading: loadingFetchQuestionnairesAnswerById} = useRequestState(fetchQuestionnairesAnswerById);
  const {loading: loadingFetchQuestionnaires} = useRequestState(fetchQuestionnaires);
  const loading = loadingFetchQuestionnairesAnswerById || loadingFetchQuestionnaires;

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchQuestionnairesAnswerById({mdqId: mdqId}));
    };
    if (mdqId) fetchData();
  }, [dispatch, mdqId]);

  if (loading) {
    return <UiPageLoading style={{backgroundColor: 'white'}} />;
  }

  return <BCPHCheckoutPopup />;
};

export default CheckoutPopup;
